import React from "react";
import LogoLight2x from "../../images/logo-white.png";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <Link to={`/`} className="logo-link">
      <img className="logo-light logo-img" src={LogoLight2x} alt="logo" />
      <img className="logo-dark logo-img" src={LogoLight2x} alt="logo" />
    </Link>
  );
};

export default Logo;
